module.exports = __webpack_public_path__ + "0a9eec98af2af2048a4b44cc82af04f0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/skateboard-green.png
// module id = 1940
// module chunks = 0